module.exports = __webpack_public_path__ + "static/media/icon-square-participants.94b73bd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-square-participants.svg
// module id = 739
// module chunks = 0